import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 *  
 * @desc Discussion thread list
 */
export function getDiscussionThreadsAction(transactionId) {
    return function (dispatch) {
        return APIUtil.getMethod(UrlConstants.threadsUrl+transactionId, true).then(response => {

            if (response.status === code.OK) {
                dispatch({
                    type: types.DISC_THREADS,
                    threads: response.data,
                });
            }
            else {
                dispatch({
                    type: types.DISC_THREADS,
                    threads: undefined
                });
            }
        });
    }
}

/**
 * 
 * @desc get message list based on type
 * @param {*} transactionId 
 * @param {*} identifier - mobile,email,id
 * @param {*} value 
 */
export function getMessagesAction(transactionId,identifier,value) {

    let url = UrlConstants.messagesUrl+transactionId;

    if(identifier == "mobile") {
        url = url + "&mobile="+value
    }
    if(identifier == "id") {
        url = url + "&email=" + value.email + "&mobile=" + value.mobile
    }
    if(identifier == "email") {
        url = url + "&email="+value
    }

    return function (dispatch) {
        return APIUtil.getMethod(url, true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.MESSAGES_LIST,
                    messages: response.data.data,
                });
            }
            else {
                dispatch({
                    type: types.MESSAGES_LIST,
                    messages: undefined
                });
            }
        });
    }
}


/**
 * 
 * @desc Reply in discussion tab
 * @param {*} data 
 * @param {*} transactionId 
 * 
 */
export function sendReplyAction(data) {
    return function (dispatch) {
        return APIUtil.postMethod(UrlConstants.replyUrl, data, true).then(response => {
            
            if (response.status === code.OK) {
                dispatch({
                    type: types.REPLY_MSG,
                    replyRes : response.data
                });
            }
           
            else {
                dispatch({
                    type: types.REPLY_MSG,
                    replyRes : {}
                });
            }
        });
    }
}


/**
 * 
 * @desc Resend message
 * @param {*} data 
 */
export function resendMsgAction(data) {
    return function (dispatch) {
        return APIUtil.postMethod(UrlConstants.resendUrl, data, true).then(response => {
            if (response.status === code.OK) {
                dispatch({
                    type: types.RESEND_MSG,
                    resendRes : response.data
                });
            }
           
            else {
                dispatch({
                    type: types.RESEND_MSG,
                    resendRes : {}
                });
            }
        });
    }
}
